module.exports = __webpack_public_path__ + "static/img/25a.8bf8a75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/25a.jpg
// module id = jfTq
// module chunks = 0